module.exports = __webpack_public_path__ + "img/行业白皮书.c3588105.png";